import React, { Component } from 'react'
import axios from 'axios'
import { Button, FieldGroup, Notification, Heading, LoadingSpinner } from '@lmig/lmds-react'
import Information1099 from './FormGroup/1099Information'
import AdditionalComments from './FormComponents/AdditionalComments'
import ContactInfo from './FormGroup/ContactInfo'
import Address from './FormGroup/Address'
import SupportingDocs from './FormGroup/SupportingDocs'
import Error from './FormError/Error'
import './FormCSS/Form.css'

class RequestAddrChange extends Component {
  state = {
    hasInvalidFields: false,
    missingFields: [],
    attachmentList: [],
    isError: false,
    isLoading: false,
    loadingStatus: '',
    requestAddrChange: {
      trackingNum: '',
      recipientName: '',
      additionalRecipients: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zipcode: '',
      country: 'United States',
      requestersName: '',
      phoneNumber: '',
      email: '',
      comments: '',
    },
  }

  // handles all state changes outside of the recipient names and attachments
  onChangeValueHandler = val => {
    let inputName = val.target.name
    let inputVal = val.target.value
    this.setState(prevState => ({
      requestAddrChange: {
        ...prevState.requestAddrChange,
        [inputName]: inputVal,
      },
    }))
  }

  // handles Additional Recipient state change
  onChangeAdditionalRecipient = val => {
    this.setState(prevState => ({
      requestAddrChange: {
        ...prevState.requestAddrChange,
        additionalRecipients: val.toString(),
      },
    }))
  }

  handleSubmit = () => {
    const missingFields = this.validateAllFields()
    const hasInvalidFields = missingFields.length !== 0
    this.setState({ hasInvalidFields, missingFields })
    if (hasInvalidFields) {
      window.scroll(0, 0)
    } else {
      this.populateTicket()
    }
  }

  //validates which fields need to be addressed
  validateAllFields() {
    const missingFields = []
    if (this.state.requestAddrChange.recipientName === '') {
      missingFields.push('Recipient name needed.')
    }
    if (this.state.requestAddrChange.address1 === '') {
      missingFields.push('Street Address is needed.')
    }
    if (this.state.requestAddrChange.city === '') {
      missingFields.push('City is needed.')
    }
    if (this.state.requestAddrChange.zipcode === '') {
      missingFields.push('Zipcode is needed.')
    }
    if (this.state.requestAddrChange.zipcode.length > 5 && this.state.requestAddrChange.zipcode.length < 10) {
      missingFields.push('Zipcode is incomplete.')
    }
    if (this.state.requestAddrChange.state === '') {
      missingFields.push('State is needed.')
    }
    if (this.state.requestAddrChange.requestersName === '') {
      missingFields.push('Requester name is needed.')
    }
    if (this.state.requestAddrChange.phoneNumber === '') {
      missingFields.push('Telephone number is needed.')
    }
    if (this.state.requestAddrChange.phoneNumber !== '' && this.state.requestAddrChange.phoneNumber.length !== 14) {
      missingFields.push('Phone number in incomplete.')
    }
    if (this.state.requestAddrChange.email !== '' && this.isValidEmail(this.state.requestAddrChange.email) === false) {
      missingFields.push('Please enter a valid email with @ symbol.')
    }
    return missingFields
  }

  isValidEmail(emailPassed) {
    const re = /\S+@\S+\.\S+/
    return re.test(emailPassed)
  }

  //this will create a ticket and pass the Jira Ticket ID to the upload attachments method, if there are attachments
  populateTicket() {
    let postUrl = '/api/createJiraTicket/ATR'
    const formData = new FormData()
    formData.append('requestData', JSON.stringify(this.state.requestAddrChange))
    // add files to data form
    this.state.attachmentList.map(aFile => formData.append('files', aFile))
    this.setState({ isLoading: true, loadingStatus: 'Creating request...' })
    axios({
      method: 'post',
      url: postUrl,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(result => {
        // 200 if there are attachments, 201 if just Jira ticket.
        if (result.status === 201 || result.status === 200) {
          this.setState({ isLoading: false, loadingStatus: '' })
          this.putTicketInState(result.data.key)
        } else {
          // error occurred that isn't a network error
          this.setState({ isLoading: false, loadingStatus: '', isError: true })
        }
      })
      .catch(error => {
        this.setState({ isLoading: false, loadingStatus: '', isError: true })
        console.error('error: ', error)
      })
  }

  extractTicketNumber(ticket) {
    const ticketRegex = /[a-zA-Z]+-([0-9]+)/
    return ticketRegex.exec(ticket)?.[1]
  }

  putTicketInState(ticketNumber) {
    window.open('/confirmationPage/2/' + this.extractTicketNumber(ticketNumber), '_self')
  }

  //adds attachments to list
  handleAttachments = filesToPass => {
    this.setState({ attachmentList: filesToPass })
  }

  // handle state change from the closeModal function in Error.js
  handleErrorPopup = isOpen => {
    this.setState({ isError: isOpen })
  }

  render() {
    let listOfMVs = this.state.missingFields.map((v, index) => (
      <li className='notification-bullet' key={index}>
        {v}
      </li>
    ))
    return (
      <>
        {this.state.isError && <Error isError={this.state.isError} update={this.handleErrorPopup} />}
        {this.state.isLoading && <LoadingSpinner />}
        <br />
        <form>
          <Heading type={'h3-light'}>Request an Address Change or 1099 Reprint Form</Heading>
          {this.state.hasInvalidFields && (
            <Notification className='notification-window' type='error'>
              <h6>Please address the following issues</h6>
              <br />
              <ul>{listOfMVs}</ul>
            </Notification>
          )}
          <br />
          <FieldGroup id='fieldgroup--requestAddrChange' disableMargins='top'>
            <div className='formBorder'>
              <div className='borderMargin'>
                <Information1099
                  additionalRecChange={this.onChangeAdditionalRecipient}
                  onChangeHandler={this.onChangeValueHandler}
                  taxIDRequired={false}
                />
                <br />
                <Address onChangeHandler={this.onChangeValueHandler} />
                <br />
                <ContactInfo onChangeHandler={this.onChangeValueHandler} />
                <br />
                <SupportingDocs
                  attachmentsList={this.handleAttachments}
                  canComment
                  maxFileSize={'20MB'}
                  maxTotalFileSize={'400MB'}
                />
                <br />
                <AdditionalComments onChangeHandler={this.onChangeValueHandler} />
                <br />
                <br />
                <Button
                  variant='primary'
                  id='test'
                  size='large'
                  onClick={this.handleSubmit}
                  disabled={this.state.isLoading}
                >
                  {this.state.isLoading ? this.state.loadingStatus : 'Submit Request'}
                </Button>
              </div>
            </div>
          </FieldGroup>
        </form>
      </>
    )
  }
}

export default RequestAddrChange
